var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-container w-100"},[(_vm.chartData && _vm.chartData.length)?_c('apexchart',{ref:"turnoverChart",attrs:{"type":"bar","height":350,"options":_vm.chartOptions,"series":_vm.formattedSeries}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }